module.exports = __webpack_public_path__ + "img/IT0000217472416.e84a1af1.png";